import { FlaskConical } from 'lucide-react';
import { DEMO_SCENARIOS, DemoScenario } from 'modules/arena/reports/source/demoSource';

interface DemoBannerProps {
  scenario: DemoScenario;
  onScenarioChange: (scenario: DemoScenario) => void;
}

// Aviso persistente de que os números são fictícios. Some só quando a integração real entra.
export function DemoBanner({ scenario, onScenarioChange }: DemoBannerProps) {
  return (
    <div
      role="note"
      className="flex flex-col gap-3 rounded-2xl border border-warning/40 bg-warning-soft px-4 py-3 text-sm sm:flex-row sm:items-center sm:justify-between"
    >
      <p className="flex items-start gap-2 text-ink">
        <FlaskConical className="mt-0.5 h-4 w-4 flex-shrink-0 text-warning" aria-hidden="true" />
        <span>
          <strong className="font-semibold">Dados de demonstração.</strong> Os números são fictícios e servem para
          apresentar o relatório. Não representam a movimentação real da arena.
        </span>
      </p>
      <label className="flex flex-shrink-0 items-center gap-2 text-xs font-medium text-ink-secondary">
        Simular cenário
        <select
          value={scenario}
          onChange={(event) => onScenarioChange(event.target.value as DemoScenario)}
          className="rounded-lg border border-border bg-surface px-2 py-1.5 text-xs text-ink focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
        >
          {DEMO_SCENARIOS.map((item) => (
            <option key={item.id} value={item.id}>
              {item.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
